import { render, staticRenderFns } from "./vehicle-model-list.vue?vue&type=template&id=8d5998a0"
import script from "./vehicle-model-list.vue?vue&type=script&lang=js"
export * from "./vehicle-model-list.vue?vue&type=script&lang=js"
import style0 from "./vehicle-model-list.vue?vue&type=style&index=0&id=8d5998a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports